import { render, staticRenderFns } from "./mdc-subtitle1.vue?vue&type=template&id=e71daa92&"
import script from "./mdc-subtitle1.vue?vue&type=script&lang=ts&"
export * from "./mdc-subtitle1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports